import { Component, Vue } from 'vue-property-decorator';
import './mode-selection.component.scss';
import { namespace } from 'vuex-class';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { WorkInstruction } from '@/tsort/enum/work-instruction.enum';
import { WorkTypeSorting } from '@/tsort/enum/work-type-sorting.enum';
import { TaskTypeSorting } from '@/tsort/enum/task-type-sorting.enum';
import { ScanSystemMenuResponse } from '@/tsort/model/response/scan-system-menu-response.model';
import NumberUtils from '@/common/utils/number.util';
import { SettingStoreConst } from '@/common/store/setting.store';
import FlashMessage from '@/common/components/flash-message.component';
import SettingService from '@/common/service/setting.service';
import AppConstants from '@/common/constants/app.constants';
import DeviceService from '@/common/service/device.service';
import { v4 as uuidv4 } from 'uuid';
import WorkInstructionModalComponent from '@/common/components/mode-selection/work-instruction-selection-modal.component';
import WorkTypeModalComponent from '@/common/components/mode-selection/work-type-selection-modal.component';
import TaskTypeModalComponent from '@/common/components/mode-selection/task-type-selection-modal.component';
import SortingService from '@/tsort/service/sorting.service';
import ErrorCdMsgConstants from '@/common/constants/error-cd-msg.constants';
import RouterUtils from '@/common/utils/router.util';
import SortingUtils from '@/common/utils/sorting.util';
import { ScanSettingResponse } from '@/tsort/model/response/scan-setting-response.model';

const SettingStore = namespace(SettingStoreConst.SETTING_STORE_MODULE_NAME);
const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
@Component({})
export default class ModeSelectionComponent extends Vue {
  // Define variavble
  listScanSystemMenu: Array<ScanSystemMenuResponse> = [];
  listWorkInstruction: Array<ScanSystemMenuResponse> = [];
  listWorkTypeSorting: Array<ScanSystemMenuResponse> = [];
  listTaskTypeSorting: Array<ScanSystemMenuResponse> = [];

  displayFlagSorting = 1;
  showButtonBackModal = false;

  // Start service
  sortingService = new SortingService();
  settingService = new SettingService();
  deviceService = new DeviceService();
  // End service

  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  authMode = config && config['AUTH_MODE'];

  // Start sort store
  @SortStore.Action
  resetTaskTypeInfo!: () => void;

  @SortStore.Action
  updateScanSystemMenu!: (value: ScanSystemMenuResponse) => void;

  @SortStore.Action
  updateLastChuteNo!: (value: string) => void;

  @SortStore.Action
  updateWesNo!: (value: number) => void;

  @SortStore.Action
  updateRFIDModeScanTarget!: (value: number) => void;

  @SortStore.Action
  updateScanSetting!: (value: ScanSettingResponse) => void;

  @SortStore.Getter
  workInstruction!: WorkInstruction;

  @SortStore.Getter
  workTypeSorting!: WorkTypeSorting;

  @SortStore.Getter
  taskTypeSorting!: TaskTypeSorting;

  @SortStore.Getter
  rfidModeScanTarget!: number;
  // End sort store

  // Start setting store
  @SettingStore.Action
  updateDeviceId!: (value: string) => void;

  @SettingStore.Action
  updateInductionId!: (value: string) => void;

  @SettingStore.Action
  updateInductionName!: (value: string) => void;

  @SettingStore.Action
  updateExternalDeviceId!: (value: string) => void;

  @SettingStore.Action
  updateGroupId!: (value: string) => void;

  @SettingStore.Getter
  inductionId!: string;

  @SettingStore.Getter
  externalDeviceId!: string;

  @SettingStore.Getter
  deviceId!: string;
  // End setting store

  async mounted(): Promise<void> {
    window.addEventListener('keydown', this.handlePressEscapeButtonEvent);
    this.resetTaskTypeInfo();
    try {
      const dataResponse = await this.sortingService.getScanSystemField();
      this.listScanSystemMenu = dataResponse;
      this.filterWorkInstruction(dataResponse);
      this.showButtonBackModal = true;
    } catch (_error) {
      return;
    }
  }

  beforeDestroy(): void {
    window.removeEventListener('keydown', this.handlePressEscapeButtonEvent);
  }

  /**
   * イベント受信 作業指示選択。
   */
  private handleModalShowWorkInstruction(uniqueWorkTypeList: Array<ScanSystemMenuResponse>): void {
    this.listWorkTypeSorting = uniqueWorkTypeList;
  }

  /**
   * イベント受信 職種選択。
   */
  private handleModalShowWorkTypeSorting(uniqueTaskTypeList: Array<ScanSystemMenuResponse>): void {
    this.listTaskTypeSorting = uniqueTaskTypeList.sort((a, b) => {
      return NumberUtils.sortAsc(a.displaySort, b.displaySort);
    });
  }

  /**
   * イベントを受け取る タスクの種類を選択する。
   */
  private handleModalTaskTypeSorting(): void {
    this.updateSortingStore();
    this.gotoPage();
  }

  /**
   * ページに移動する。
   */
  async gotoPage(): Promise<void> {
    this.$bvModal.hide('idWorkInstructionModal');
    this.$bvModal.hide('idWorkTypeModal');
    this.$bvModal.hide('idTaskTypeModal');
    let targetPage;
    if (SortingUtils.isNoWorkInstruction) {
      targetPage = SortingUtils.isSingleSorting
        ? AppConstants.NAME_NO_TASK_SINGLE_SORTING_PAGE
        : AppConstants.NAME_NO_TASK_MULTI_SORTING_PAGE;
    } else {
      if (SortingUtils.isSingleSorting) {
        targetPage = AppConstants.NAME_SINGLE_SORTING_PAGE;
      } else if (SortingUtils.isMultiSorting) {
        targetPage = AppConstants.NAME_MULTI_SORTING_PAGE;
      } else if (SortingUtils.isHandSorting) {
        if (!this.externalDeviceId) {
          this.updateExternalDeviceId(`Ta${uuidv4()}`);
        }
        targetPage = AppConstants.NAME_HAND_SORTING_PAGE;
      }
    }
    // リンク誘導をチェックする
    if (targetPage) {
      await this.checkLinkInduction(targetPage);
    }
  }

  /**
   * リンク誘導。
   * @param namePage 名前ページ
   */
  async checkLinkInduction(namePage: string): Promise<void> {
    try {
      const dataResponse = await this.settingService.getLinkInduction(this.externalDeviceId, AppConstants.DEVICE_TYPE);
      if (dataResponse && dataResponse.mstInduction) {
        this.updateInductionId(dataResponse.mstInduction.inductionId);
        this.updateInductionName(dataResponse.mstInduction.inductionName);
        this.updateDeviceId(dataResponse.mstInduction.deviceId);
      } else {
        this.updateInductionId('');
        this.updateInductionName('');
      }
      if (!this.inductionId && namePage !== AppConstants.NAME_HAND_SORTING_PAGE) {
        await RouterUtils.replaceRouterName(AppConstants.NAME_SETTING_PAGE);
        FlashMessage.getInstance().showErrorMsgWithErrorCode(
          ErrorCdMsgConstants.FUNC_SELECT_MODE_WITHOUT_SELECTING_INDUCTION_ERR_CD,
          ErrorCdMsgConstants.FUNC_SELECT_MODE_WITHOUT_SELECTING_INDUCTION_ERR_MSG
        );
      } else {
        if (!this.authMode || (this.deviceId && namePage === AppConstants.NAME_HAND_SORTING_PAGE)) {
          const dataResponse = await this.deviceService.createDevice(this.externalDeviceId).catch(async (error) => {
            await RouterUtils.replaceRouterName(AppConstants.NAME_SETTING_PAGE);
            return error;
          });
          if (dataResponse && dataResponse.mstDevice) {
            this.updateDeviceId(dataResponse.mstDevice.deviceId);
          }
        }
        await RouterUtils.replaceRouterName(namePage);
      }
    } catch (error) {
      this.updateInductionId('');
      this.updateInductionName('');
      await RouterUtils.replaceRouterName(AppConstants.NAME_SETTING_PAGE);
      FlashMessage.getInstance().showErrorMsgWithErrorCode(
        ErrorCdMsgConstants.FUNC_SELECT_MODE_WITHOUT_SELECTING_INDUCTION_ERR_CD,
        ErrorCdMsgConstants.FUNC_SELECT_MODE_WITHOUT_SELECTING_INDUCTION_ERR_MSG
      );
      return;
    }
  }

  /**
   * データストレージの更新。
   */
  private updateSortingStore(): void {
    const scanSystemMenu = this.listScanSystemMenu
      .filter((item) => item.workInstruction === this.workInstruction)
      .filter((item) => item.workType === this.workTypeSorting)
      .filter((item) => item.taskType === this.taskTypeSorting)
      .map((item) => item);
    this.updateScanSystemMenu(scanSystemMenu[0]);
    this.updateLastChuteNo('');
    this.updateWesNo(0);
  }

  /**
   * フィルター作業指示。
   */
  private filterWorkInstruction(res: ScanSystemMenuResponse[]): void {
    // フィルタデータ作業指示
    const uniqueWorkInstruction = [...new Set(res.filter((item) => item.displayFlag === this.displayFlagSorting))];
    this.listWorkInstruction = uniqueWorkInstruction;
  }

  /**
   * 職場復帰指示モーダル。
   */
  private backWorkInstructionModal(): void {
    // フィルターデータ固有の作業誘導
    const listWorkInstructionUnique = [...new Set(this.listWorkInstruction.map((item) => item.workInstruction))];
    const uniqueWorkInstructions = listWorkInstructionUnique.sort((a, b) => b - a);
    if (uniqueWorkInstructions.length > 1) {
      this.$bvModal.show('idWorkInstructionModal');
    } else {
      RouterUtils.goToRouterName(AppConstants.NAME_TOP_PAGE);
    }
  }

  /**
   * 作業タイプモーダルに戻る。
   */
  private backWorkTypeModal(): void {
    // フィルターデータ固有のワークタイプ
    const listWorkTypeUnique = [
      ...new Set(
        this.listWorkTypeSorting
          .filter((item) => item.workInstruction === this.workInstruction)
          .filter((item) => item.displayFlag === this.displayFlagSorting)
          .map((item) => item.workType)
      )
    ];
    const uniqueWorkInstructions = listWorkTypeUnique.sort((a, b) => b - a);
    if (uniqueWorkInstructions.length > 1) {
      this.$bvModal.show('idWorkTypeModal');
    } else {
      this.backWorkInstructionModal();
    }
  }

  /**
   * Escapeボタンが押されたときのイベントを処理します。
   *
   * @param e KeyboardEvent - キーボードイベント
   */
  handlePressEscapeButtonEvent(e: KeyboardEvent): void {
    if (e.key === 'Escape') {
      RouterUtils.goToRouterName(AppConstants.NAME_TOP_PAGE);
    }
  }

  render() {
    return (
      <div class="mode-selection-page">
        {/* Modal work induction */}
        <WorkInstructionModalComponent
          listWorkInstruction={this.listWorkInstruction}
          onWorkInstructionSelected={this.handleModalShowWorkInstruction}
        />
        {/* Modal work type sorting */}
        <WorkTypeModalComponent
          listWorkTypeSorting={this.listWorkTypeSorting}
          onWorkTypeSelected={this.handleModalShowWorkTypeSorting}
          showButtonBackModal={this.showButtonBackModal}
          onBackWorkInstructionModal={() => this.backWorkInstructionModal()}
        />
        {/* Modal task type sorting */}
        <TaskTypeModalComponent
          listTaskTypeSorting={this.listTaskTypeSorting}
          onTaskTypeSelected={this.handleModalTaskTypeSorting}
          showButtonBackModal={this.showButtonBackModal}
          onBackWorkTypeModal={() => this.backWorkTypeModal()}
        />
      </div>
    );
  }
}
